import React from 'react';
const fragments: { [key: string]: string } = {
  templated: 'Templated',
  'grant-details': 'GrantDetails',
  summary: 'Summary',
  table: 'Table',
  tableOverYears: 'TableOverYears',
  list: 'List',
  overview: 'Overview',
  'terms-of-use': 'TermsOfUse',
  'publications-list': 'PublicationsList',
};

export const seriesChartList = [
  'area',
  'bar',
  'column',
  'line',
  'multipleAxis',
  'percentStackedBar',
  'percentStackedColumn',
  'sankey',
  'stackedBar',
  'stackedColumn',
];

const chartList = ['bubble', 'scatter', 'pie', 'map', 'sunburst', ...seriesChartList];

export const getFragmentType = (type: string): string => (type.includes('+') ? 'multipleAxis' : type);

export const isSeries = (type: string): boolean => {
  const expectedType = getFragmentType(type);
  return seriesChartList.includes(expectedType);
};

export function getFragmentByType(type: string): any {
  const expectedType = getFragmentType(type);
  const isChart = chartList.includes(expectedType);
  const fragmentName = isChart ? 'Chart' : fragments[expectedType];

  return fragmentName ? (
    React.lazy(
      () =>
        import(
          /* webpackInclude: /\.tsx$/ */
          /* webpackExclude: /\.test\.tsx$/ */
          /* webpackMode: "lazy" */
          `./${fragmentName}/${fragmentName}`
        ),
    )
  ) : (
    <p>Fragment not found</p>
  );
}
